import { type Challenge, type SetComplexImmerStateAction } from '@/lib/types';
import { createContext } from 'react';

const ChallengeContext = createContext<
  [Challenge, SetComplexImmerStateAction<Challenge>]
>([null as unknown as Challenge, () => {}]);

export default ChallengeContext;
